import React from 'react'
import useTranslation from '../useTranslation'
import './LiveBattingTable.scss'

export default function LiveBattingTable({ scoreboard }) {
    const Batter = useTranslation('Batter')
    const R = useTranslation('R')
    const B = useTranslation('B')
    const a4s = useTranslation('4s')
    const a6s = useTranslation('6s')

    const {
        bat1name,
        bat1runs,
        bat1balls,
        bat1fours,
        bat1sixes,
        bat2name,
        bat2runs,
        bat2balls,
        bat2fours,
        bat2sixes
    } = scoreboard || {};

    return (
        <div className="live-batting-table">
            <div className="live-batting-table-header">
                <div>{Batter}</div>
                <div>{R}</div>
                <div>{B}</div>
                <div>{a4s}</div>
                <div>{a6s}</div>
            </div>
            <div className="live-batting-table-row">
                <div>{bat1name}</div>
                <div>{bat1runs}</div>
                <div>{bat1balls}</div>
                <div>{bat1fours}</div>
                <div>{bat1sixes}</div>
            </div>
            <div className="live-batting-table-row">
                <div>{bat2name}</div>
                <div>{bat2runs}</div>
                <div>{bat2balls}</div>
                <div>{bat2fours}</div>
                <div>{bat2sixes}</div>
            </div>
        </div>
    )
}
